enum ResponsibleInvoiceStatus {
  'PENDING',
  'PROCESSED',
}

export default ResponsibleInvoiceStatus;
